<template>
	<div class="custom-company">
		<item v-for="(field, index) in fields" :i="field" v-on:remove="deleteField(index)" :key="index"></item>

		<div class="custom-company__add-wrapper" v-if="!fields.length">
			или <button type="button" class="custom-company__add" @click="addField()">добавьте новую</button>
		</div>
		<div class="custom-company__add-wrapper" v-else>
			<button type="button" class="custom-company__add" @click="addField()">добавить еще</button>
		</div>

	</div>
</template>

<script>
export default {
  data: function() {
    return {
      fields: []
    };
  },
  methods: {
    addField: function() {
      var count = this.fields.length;
      this.fields.push(count);
    },
    deleteField: function(index) {
      this.fields.splice(index, 1);
    }
  },
  components: {
    item: require("./item.vue").default
  }
};
</script>

<style scoped>
.custom-company__add-wrapper {
  color: #9ba3af;
  font-size: 12px;
  margin-top: 10px;
}
.custom-company__add {
  border: 0;
  border-bottom: 1px dotted;
  padding: 0;
  margin: 0;
  background: none;
}
.custom-company__add:hover {
  border-bottom-color: transparent;
}
.custom-company__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
}
@media (min-width: 768px) {
  .custom-company__row {
    flex-direction: row;
  }
}
</style>